<template>
    <div>
        <div class="field">
            <p class="text">
                {{ 'components.pages.profile.exclusion.description' | translate }}
            </p>
        </div>
        <div class="field">
            <label>{{ 'components.pages.profile.exclusion.password' | translate }}</label>
            <div class="control has-icons-left has-icons-right">
                <input
                    v-model="password"
                    v-validate="`required|max:50`"
                    data-vv-name="password"
                    data-vv-validate-on="change"
                    :error-messages="errors.collect('password')"
                    :class="{ 'is-danger': errors.has('password') }"
                    :type="showPassword ? 'text' : 'password'"
                    :readonly="loading"
                    class="input"
                    ref="password"
                    @focus="
                        () => {
                            errors.remove('password', 'serverErrors');
                        }
                    "
                />
                <span class="icon is-small is-left">
                    <i class="fas fa-lock"></i>
                </span>
                <a class="icon is-small is-right bng-clickable" @click="toggleShowPassword('password')">
                    <span v-show="!showPassword">
                        <i class="far fa-eye-slash"></i>
                    </span>
                    <span v-show="showPassword">
                        <i class="far fa-eye"></i>
                    </span>
                </a>
            </div>
            <p class="help is-danger" v-if="errors.has('password:required')">
                {{ 'components.pages.profile.validation.field required' | translate }}
            </p>
            <p class="help is-danger" v-if="errors.has('password:max')">
                {{ 'components.pages.profile.validation.password max length' | translate }}
            </p>
            <p class="help is-danger" v-if="errors.has('password:wrongPassword', 'serverErrors')">
                {{ 'components.pages.profile.exclusion.WrongPassword' | translate }}
            </p>
            <p class="help is-danger" v-if="errors.has('password:general', 'serverErrors')">
                {{ 'components.pages.profile.exclusion.general error' | translate }}
            </p>
        </div>

        <div class="field">
            <div class="control submit-buttons">
                <button class="button is-link button-submit" @click="openModal" :disabled="loading">
                    {{ 'components.pages.profile.exclusion.button' | translate }}
                </button>
            </div>
        </div>
        <lockout @userExclude="userExclusion" :isOpen="showModal" :closeModal="closeModal" />
    </div>
</template>

<script>
import Vue from 'vue';
import Lockout from '../../../common/modals/lockout/lockout.vue';
import playerService from '../../../../../../_common/services/player.service';

export default {
    name: 'profile-exclusion',
    components: { Lockout },
    $_veeValidate: { validator: 'new' },
    data() {
        return {
            password: null,
            showPassword: false,
            showModal: false,
            loading: false
        };
    },

    methods: {
        async userExclusion(value) {
            if (!value) return;

            await this.$validator.validateAll();
            if (this.$validator.errors.any()) return;

            this.loading = true;
            try {
                const result = await playerService.playerLock(this.password);
                if (result && result.error) {
                    this.errors.add({ field: 'password', rule: 'wrongPassword', msg: 'wrongPassword', scope: 'serverErrors' });
                } else {
                    await Vue.state.player.logout();
                    this.$router.push('/');
                }
            } catch (error) {
                this.errors.add({ field: 'password', rule: 'general', msg: 'general', scope: 'serverErrors' });
            } finally {
                this.loading = false;
            }
        },
        async openModal() {
            await this.$validator.validateAll();
            if (this.$validator.errors.any()) return;

            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        toggleShowPassword(ref) {
            this.showPassword = !this.showPassword;
            setTimeout(() => this.$refs[ref].focus());
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/profile/exclusion.vue